<template>
  <div>
    <el-dialog
      append-to-body
      top="5vh"
      :title="title"
      :visible.sync="visibleSync"
      width="60%"
      :before-close="onCancel"
    >
      <el-table
        :cell-class-name="pintar"
        row-class-name="rowClassTablaPloma"
        header-cell-class-name="header-cell-class-table-gray"
        @selection-change="handleSelectionChange"
        :default-sort="{prop: 'mfl', order: 'descending'}"
        class="tableRisks"
        :data="risks"
        style="width: 100%"
        :max-height="520"
        empty-text="Sin Riesgos estandarizados"
      >
        <el-table-column type="expand" width="40" label="+">
          <template slot-scope="scope">
            <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 20px;">
              <el-row>
                <el-col :span="8">
                  <h4>Causas</h4>
                  <ol>
                    <li v-for="(item, index) in scope.row.causas" :key="index">{{item.nombre}}</li>
                  </ol>
                </el-col>
                <el-col :span="8">
                  <h4>Controles Preventivos</h4>
                  <ol>
                    <li
                      :class="{fontRed: control.critico}"
                      v-for="(control, i) in getControlesPreventivos(scope.row)"
                      v-bind:key="i"
                    >{{control.nombre}}</li>
                  </ol>
                </el-col>
                <el-col :span="8">
                  <h4>Controles Mitigadores</h4>
                  <ol>
                    <li
                      v-for="(control, i) in getControlesMitigadores(scope.row)"
                      v-bind:key="i"
                    >{{control.nombre}}</li>
                  </ol>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" type="selection"></el-table-column>
        <el-table-column prop="nombre" label="Nombre"></el-table-column>
        <el-table-column width="80" align="center" label="Impacto">
          <template slot-scope="scope">{{getMayorImpacto(scope.row).mfl}}</template>
        </el-table-column>
        <el-table-column width="80" align="center" label="MFL">
          <template slot-scope="scope">
            <el-tag
              class="big"
              v-bind:type="mflRange(getMayorImpacto(scope.row).mfl)"
            >{{getMayorImpacto(scope.row).mfl}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="80" align="center" label="FS">
          <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto.factor_severidad}}</template>
        </el-table-column>
        <el-table-column width="80" align="center" label="FP">
          <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto.factor_probabilidad}}</template>
        </el-table-column>
        <el-table-column width="80" align="center" label="RRR">
          <template slot-scope="scope">
            <el-tag class="big" type="gray">{{getMayorImpacto(scope.row).rrr}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="80" align="center" label="NSR">
          <template slot-scope="scope">{{getMayorImpacto(scope.row).impacto.nivel_severidad}}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="onCancel">Cancelar</el-button>
        <el-button size="medium" type="primary" @click="onAcept">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'onCancel',
    'onAcept',
    'risks',
    'visibleSync',
    'title',
    'handleSelectionChange',
  ],
  methods: {
    pintar({
      row, column, rowIndex, columnIndex,
    }) {
      let classes = 'cellClassTablaPloma ';
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += 'colorCustom';
        } else if (row.impactos[0].categoria === 'Seguridad' && !row.custom) {
          classes += 'colorSeguridad';
        } else if (row.impactos[0].categoria === 'Salud' && !row.custom) {
          classes += 'colorSalud';
        } else if (
          row.impactos[0].categoria === 'Salud y Seguridad'
          && !row.custom
        ) {
          classes += 'colorSaludySeguridad';
        } else if (
          row.impactos[0].categoria === 'Medioambiente'
          && !row.custom
        ) {
          classes += 'colorMedioambiente';
        }
      }
      return classes;
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return 'danger';
      }
      if (mfl === 3) {
        return 'warning';
      }
      return 'gray';
    },
    getMayorImpacto(risk) {
      let mfl = 0;
      let rrr;
      let mayorImpacto;

      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr = (impacto.factor_severidad
                * 10
                * (impacto.factor_probabilidad * 10))
              / (10 * 10);
            mayorImpacto = impacto;
          }
        });
      }

      return {
        impacto: mayorImpacto,
        mfl,
        rrr,
      };
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map(key => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
      }));
      return controles;
    },
  },
};
</script>

<style scoped>
.fontRed {
  color: red;
}
</style>
